module.exports = __webpack_public_path__ + "static/media/news.b9ba6c2a.svg";